<template>
  <DialogHeader> Move {{ props.ids.length }} items </DialogHeader>
  <DialogContent>
    Are you sure you want to move {{ props.ids.length }} items to
    <span class="font-medium">{{ props.folder.name }}</span
    >?
  </DialogContent>
  <DialogFooter>
    <UiButton
      class="w-1/2 tablet-h:w-auto mr-2.5 tablet-h:mr-2"
      :disabled="loading"
      @click="close()"
    >
      Cancel
    </UiButton>
    <UiButton
      :disabled="loading"
      :loading="loading"
      class="w-1/2 tablet-h:w-auto"
      primary
      @click="handleClick"
    >
      Okay
    </UiButton>
  </DialogFooter>
</template>

<script setup lang="ts">
import type { Folder } from '@/shared/graphql/router/graphql'
import DialogHeader from '@/shared/dialogs/DialogHeader.vue'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import DialogFooter from '@/shared/dialogs/DialogFooter.vue'
import { useDialog } from '@/shared/dialogs/useDialog'
import { ref } from 'vue'
import { UiButton } from '@dacr/ui'

const { close } = useDialog()
const { closeAll } = useDialog()

const props = defineProps<{
  folder: Folder
  ids: string[]
  callback: () => Promise<void>
}>()

const loading = ref(false)

const handleClick = async () => {
  loading.value = true

  await props.callback()

  closeAll()
}
</script>
